<div class="container-fluid user-profile" *ngIf="loginDetails$ | async; let loginDetails">
  <div *ngIf="loginDetails.currentProfile">
    <app-onboarding
      [userProfile]="loginDetails.currentProfile"
    >
    </app-onboarding>
  </div>
</div>
